import React, { useState, useEffect } from "react";
import { Table, Select, Button, message, Checkbox } from "antd";
import {
  getUserList,
  fetchPermission,
  savePermission,
} from "../../Services/Services";

const { Option } = Select;

const AssignPage = () => {
  const [staffList, setStaffList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [assignedPages, setAssignedPages] = useState({});
  const [loading, setLoading] = useState(false);

  const sidebarPages = [
    { key: "addclients", label: "Clients" },
    { key: "lifter-user", label: "Lifter" },
    { key: "staff-user", label: "Staff" },
    { key: "entry_do_no", label: "DO Number" },
    { key: "lifter-assign-view", label: "Lifter DO" },
    { key: "lifter-dispatch-view", label: "Dispatch" },
    { key: "freight-pay", label: "Freight Pay" },
    { key: "lifter-payment-view", label: "Lifter Pay" },
    { key: "party-payment-view", label: "Party Pay" },
    { key: "Order_form", label: "Order Today" },
    { key: "all_order", label: "All Orders" },
    { key: "bill-view", label: "Bill View" },
    // { key: "Order-entry", label: "Order Entry" },
  ];

  const reportPages = [
    { key: "do_status", label: "Do Status" },
    { key: "do_pending_for_bill", label: "Do Pending For Bill" },
    { key: "do_bill_register", label: "Do Bill Register" },
    { key: "sale_do", label: "Sale Do List" },
    { key: "leps_do", label: "Leps Do List" },
    { key: "DispacthStatus", label: "Freight Status By DO" },
    { key: "MonthlyReport", label: "Monthly Freight Report" },
    { key: "YearlyReport", label: "Yearly Freight Report" },
    { key: "CustomReport", label: "Custom Freight Report" },
    { key: "FreightPaymetRegister", label: "Freight Payment Register" },
    { key: "PendingFreightPaymet", label: "Pending Freight Payment" },
    { key: "TdsFreightList", label: "TDS Freight List" },
    { key: "FreightNotApplicableList", label: "Freight Not Applicable List" },
  ];

  useEffect(() => {
    fetchStaffList();
  }, []);

  const fetchStaffList = async () => {
    try {
      const data = await getUserList();
      if (Array.isArray(data)) {
        const filtered = data.filter(
          (o) =>
            o.user_type === "Staff" &&
            o.com_name === localStorage.getItem("com_name")
        );
        setStaffList(filtered);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch staff list.");
    }
  };

  useEffect(() => {
    if (selectedStaff) fetchAssignedPages(selectedStaff);
  }, [selectedStaff]);

  const fetchAssignedPages = async (userId) => {
    try {
      const data = await fetchPermission(userId);
      const assigned = {};
      (data.label || []).forEach((page) => {
        assigned[page] = true;
      });
      setAssignedPages(assigned);
    } catch (err) {
      console.error(err);
      setAssignedPages({});
    }
  };

  const handleCheckboxChange = (key) => {
    setAssignedPages((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleMasterToggle = (type, checked) => {
    const pages = type === "sidebar" ? sidebarPages : reportPages;
    const updates = {};
    pages.forEach((p) => {
      updates[p.key] = checked;
    });
    setAssignedPages((prev) => ({ ...prev, ...updates }));
  };

  const handleAssign = async () => {
    if (!selectedStaff) {
      message.warning("Please select a staff member first!");
      return;
    }

    const selectedPageKeys = Object.keys(assignedPages).filter(
      (k) => assignedPages[k]
    );
    if (selectedPageKeys.length === 0) {
      message.warning("Please select at least one page.");
      return;
    }

    setLoading(true);
    try {
      await savePermission(selectedStaff, selectedPageKeys);
      message.success("Permissions saved successfully!");
    } catch (err) {
      console.error(err);
      message.error("Failed to save permissions.");
    } finally {
      setLoading(false);
    }
  };

  const allSidebarSelected = sidebarPages.every((p) => assignedPages[p.key]);
  const allReportsSelected = reportPages.every((p) => assignedPages[p.key]);

  return (
    <div style={{ padding: 20, backgroundColor: "#fff", minHeight: "100vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 20,
          marginBottom: 30,
        }}
      >
        <Select
          placeholder="Select Staff"
          style={{ width: 250 }}
          onChange={(value) => setSelectedStaff(value)}
          value={selectedStaff || null}
          allowClear
        >
          {staffList.map((staff) => (
            <Option key={staff.id} value={staff.id}>
              {staff.name}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          onClick={handleAssign}
          loading={loading}
          style={{
            padding: "0 25px",
            height: "33px",
            background: "linear-gradient(135deg, #4f46e5, #3b82f6)", // gradient professional look
            border: "none",
            borderRadius: "6px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            fontWeight: 600,
            fontSize: 14,
            color: "#fff",
          }}
        >
          Assign Selected Pages
        </Button>
      </div>

      <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
        {/* Sidebar Pages */}
        <div
          style={{
            flex: 1,
            minWidth: "350px",
            background: "#f9fafb",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            padding: "20px",
            transition: "0.3s",
          }}
        >
          {/* Header with Master Checkbox */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "linear-gradient(135deg, #3b82f6, #2563eb)",
              color: "white",
              borderRadius: "10px",
              padding: "10px 15px",
              marginBottom: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            <span style={{ fontWeight: 600, fontSize: "15px" }}>
              Sidebar Permissions
            </span>
            <Checkbox
              checked={allSidebarSelected}
              onChange={(e) => handleMasterToggle("sidebar", e.target.checked)}
              style={{
                color: "white",
                fontWeight: 500,
                transform: "scale(1.2)",
              }}
            >
              Select All
            </Checkbox>
          </div>

          {/* Sidebar List */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
              gap: "10px 20px",
            }}
          >
            {sidebarPages.map((p) => (
              <div
                key={p.key}
                style={{
                  padding: "8px 12px",
                  borderRadius: "8px",
                  background: assignedPages[p.key]
                    ? "rgba(37,99,235,0.08)"
                    : "transparent",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = assignedPages[p.key]
                    ? "rgba(37,99,235,0.15)"
                    : "rgba(59,130,246,0.08)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(59,130,246,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = assignedPages[p.key]
                    ? "rgba(37,99,235,0.08)"
                    : "transparent";
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <Checkbox
                  checked={assignedPages[p.key] || false}
                  onChange={() => handleCheckboxChange(p.key)}
                >
                  {p.label}
                </Checkbox>
              </div>
            ))}
          </div>
        </div>

        {/* Report Pages */}
        <div
          style={{
            flex: 1,
            minWidth: "350px",
            background: "#f9fafb",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            padding: "20px",
            transition: "0.3s",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "linear-gradient(135deg, #10b981, #059669)",
              color: "white",
              borderRadius: "10px",
              padding: "10px 15px",
              marginBottom: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            <span style={{ fontWeight: 600, fontSize: "15px" }}>
              Report Permissions
            </span>
            <Checkbox
              checked={allReportsSelected}
              onChange={(e) => handleMasterToggle("reports", e.target.checked)}
              style={{
                color: "white",
                fontWeight: 500,
                transform: "scale(1.2)",
              }}
            >
              Select All
            </Checkbox>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
              gap: "10px 20px",
            }}
          >
            {reportPages.map((p) => (
              <div
                key={p.key}
                style={{
                  padding: "8px 12px",
                  borderRadius: "8px",
                  background: assignedPages[p.key]
                    ? "rgba(16,185,129,0.1)"
                    : "transparent",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = assignedPages[p.key]
                    ? "rgba(16,185,129,0.15)"
                    : "rgba(5,150,105,0.08)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(5,150,105,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = assignedPages[p.key]
                    ? "rgba(16,185,129,0.1)"
                    : "transparent";
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <Checkbox
                  checked={assignedPages[p.key] || false}
                  onChange={() => handleCheckboxChange(p.key)}
                >
                  {p.label}
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignPage;
